export const CANDIDATE = {
  name: "Amin Nanji",
  office: "Ward 11 City Councillor · Mississauga",
  tagline: "A stronger voice for Ward 11.",
  subline: "Practical leadership. Real listening. Results that put residents first.",
  phone: "416-821-0891",
  email: "aminvoteward11@gmail.com",
  quote: "Communities know what they need. They just need someone who will listen carefully and act.",
  statement:
    "I’m running for Ward 11 City Councillor because our neighbourhoods deserve a representative who understands the challenges we face, respects every tax dollar, and treats residents as partners—not afterthoughts.",
};

export const IMAGES = {
  portraitHero:
    "https://images.unsplash.com/photo-1785921697232-121a8011d4b8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBtYW4lMjBtYXR1cmUlMjBwb3J0cmFpdCUyMHN1aXR8ZW58MHx8fHwxNzg3NjkzNzgwfDA&ixlib=rb-4.1.0&q=85",
  portraitBio: "/images/about-food-drive.webp",
  cityscape:
    "https://images.pexels.com/photos/36611308/pexels-photo-36611308.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  skyline:
    "https://images.pexels.com/photos/36611318/pexels-photo-36611318.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  volunteers:
    "https://images.pexels.com/photos/6646873/pexels-photo-6646873.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  streetsville:
    "https://images.unsplash.com/photo-1762231433404-04be830b0f3b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwxfHxjb21tdW5pdHklMjB0b3duJTIwaGFsbCUyMG1lZXRpbmclMjB2b2x1bnRlZXIlMjBjaXZpY3xlbnwwfHx8fDE3ODc2OTM3ODB8MA&ixlib=rb-4.1.0&q=85",
  civic:
    "https://images.pexels.com/photos/7103117/pexels-photo-7103117.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  towers: "https://images.unsplash.com/photo-1563734769255-5fdadc94747b?q=85&w=1200&auto=format&fit=crop",
  glass: "https://images.unsplash.com/photo-1467806757054-808649965a76?q=85&w=1200&auto=format&fit=crop",
  road: "https://images.unsplash.com/photo-1730838410304-88a33896d041?q=85&w=1200&auto=format&fit=crop",
  park: "https://images.unsplash.com/photo-1720187216642-8f169f93e93e?q=85&w=1200&auto=format&fit=crop",
  night: "https://images.unsplash.com/photo-1581141117898-2be4de754b12?q=85&w=1200&auto=format&fit=crop",
  family: "/images/family.webp",
  flyer: "/images/campaign-flyer.webp",
};

export const COMMITMENTS = [
  {
    number: "01",
    slug: "real-voice",
    title: "A Real Voice for Every Neighbourhood",
    short: "A volunteer-driven feedback system with representatives from every corner of Ward 11 — met monthly, heard first.",
    why: "Streetsville, Meadowvale Village, Levi Creek, Credit Mills and our surrounding communities each have their own character and challenges. Residents know their streets and needs better than anyone — yet too often decisions are made before anyone asks them. Ward 11 deserves a councillor who listens first and acts.",
    actions: [
      "Establish a volunteer-driven feedback system with representatives from each subsection of Ward 11 — including Streetsville, Meadowvale Village, Levi Creek, and Credit Mills.",
      "Meet with these neighbourhood representatives every single month, for the full term.",
      "Bring resident feedback directly into council decisions — before votes are cast, not after.",
    ],
    img: IMAGES.volunteers,
  },
  {
    number: "02",
    slug: "responsible-growth",
    title: "Responsible Growth That Protects What Matters",
    short: "Development must strengthen our communities, not overwhelm them. Infrastructure first — always.",
    why: "Growth is coming to Ward 11 — the question is whether it works for the people who already call it home. New development must never outpace the infrastructure, hospital capacity, schools, and roads that families depend on, and it must respect the heritage character that makes our villages unique.",
    actions: [
      "Demand that infrastructure, hospital capacity, schools, and traffic impacts keep pace with any new growth.",
      "Apply heightened scrutiny to development pressure near Erin Mills Town Centre.",
      "Protect the heritage character of Streetsville and Meadowvale Village in every planning decision.",
    ],
    img: IMAGES.skyline,
  },
  {
    number: "03",
    slug: "safer-streets",
    title: "Safer Streets and Smarter Traffic Solutions",
    short: "Proven traffic calming, data-driven fixes, and modern technology — safer streets for families, seniors, and children.",
    why: "Speeding, cut-through traffic, and pedestrian safety are real concerns on Ward 11 streets. These aren't abstract issues — they affect children walking to school, seniors crossing their own streets, and families cycling through their neighbourhoods.",
    actions: [
      "Push for physical traffic calming where residents have asked for it most.",
      "Use data-driven improvements to target the worst speeding and cut-through corridors.",
      "Adopt modern traffic technology already proven in other cities — not theory, but tools that work.",
    ],
    img: IMAGES.road,
  },
  {
    number: "04",
    slug: "taxpayer-respect",
    title: "Respect for Taxpayers",
    short: "Every tax dollar belongs to the people who earned it. Discipline at City Hall before any ask of residents.",
    why: "Families and local businesses in Ward 11 work hard for every dollar. Before City Hall asks residents to pay more, it must show that every dollar it already collects is spent wisely. Affordability is not a slogan — it is a discipline.",
    actions: [
      "Bring thirty years of business and engineering discipline to every budget line.",
      "Require proof that existing dollars are spent wisely before supporting any new burden on residents.",
      "Champion affordability for families, seniors on fixed incomes, and local businesses.",
    ],
    img: IMAGES.towers,
  },
  {
    number: "05",
    slug: "practical-solutions",
    title: "Practical Solutions Drawn from the Best",
    short: "Proven practices from cities that solved the same problems — because results matter more than ideology.",
    why: "Ward 11's challenges are not unique — cities around the world have tackled traffic, growth, and service delivery successfully. There is no prize for reinventing the wheel when proven solutions already exist.",
    actions: [
      "Study and adopt proven practices from cities that have solved the same challenges we face.",
      "Build on the tools and programs Mississauga already has instead of starting from scratch.",
      "Use technology pragmatically to deliver better services at lower cost.",
    ],
    img: IMAGES.glass,
  },
  {
    number: "06",
    slug: "accessible-representation",
    title: "Accessible, Accountable Representation",
    short: "Regular updates. Clear explanations. An open door for the full term — not just at election time.",
    why: "Representation doesn't end on election day — it begins. Ward 11 residents should always know where their councillor stands, why decisions were made, and exactly how to reach him.",
    actions: [
      "Publish regular updates and clear explanations of council decisions.",
      "Keep an open door — and a direct phone line and email — throughout the full term.",
      "Report back to every neighbourhood, not just the loudest voices.",
    ],
    img: IMAGES.civic,
  },
];

export const NEIGHBOURHOODS = [
  {
    name: "Streetsville",
    tag: "The Village in the City",
    desc: "Historic charm, the Queen Street business core, Bread and Honey heritage, and a walkable main street worth protecting.",
    img: "/images/streetsville.webp",
  },
  {
    name: "Meadowvale Village",
    tag: "Ontario's First Heritage Conservation District",
    desc: "Scenic Credit River valley, centuries-old trees, and architectural integrity that must never be zoned away.",
    img: "/images/meadowvale-village.webp",
  },
  {
    name: "Levi Creek",
    tag: "A Thriving Family Community",
    desc: "Top-tier schools, sprawling parks, and active youth sports — where traffic safety around schools matters most.",
    img: "/images/levi-creek.webp",
  },
  {
    name: "Credit Mills",
    tag: "Signature Neighbourhood",
    desc: "Mature tree canopies and established streets near the Credit Valley Hospital corridor — where growth pressure is felt first.",
    img: "/images/credit-mills.webp",
  },
];

export const BIO_TIMELINE = [
  {
    period: "1972",
    title: "Displacement and a New Beginning",
    text: "Born in Uganda, Amin was still a young child when his family was expelled under Idi Amin’s regime in 1972. They found temporary safety in a refugee camp in Sweden before building a new life in Canada. That experience of displacement and starting over instilled a lifelong belief in the power of community, the value of opportunity, and the need for systems that truly serve people.",
  },
  {
    period: "35+ YEARS",
    title: "Mississauga Is Home",
    text: "He has lived and worked in Mississauga for over 35 years with his wife and three sons — more than 30 of them in Ward 11. His children attended local schools, took part in community programs, and volunteered with neighbourhood organizations. Mississauga is not just where he lives — it is home.",
  },
  {
    period: "20 YEARS",
    title: "Engineering & Global Manufacturing",
    text: "After earning a Bachelor’s degree in Mechanical Engineering and Management from McMaster University, Amin spent twenty years with a global manufacturing company across operations, global supply chain, financial reporting, and software implementation — learning to solve complex problems, manage resources carefully, and deliver results under pressure.",
  },
  {
    period: "11 YEARS",
    title: "Local Business Owner",
    text: "He then spent eleven years successfully acquiring, amalgamating, and operating two food distribution companies — gaining firsthand experience in local business, logistics, and keeping essential services running for the people who depend on them.",
  },
  {
    period: "A LIFETIME",
    title: "Service as a Constant",
    text: "Service has always been a constant in his life. In his twenties, he began volunteering as a Big Brother and later became Director of Volunteer Operations. For the past 16 years, he has also volunteered as a math teacher with the Academic Achievement Community Program, helping young people build confidence and reach their potential. More recently, he led a civic team that organized large-scale food and book drives, bringing neighbours together and connecting families with needed resources. Through every stage of his life, serving his community has given him a genuine sense of purpose and strengthened his belief in the power of people working together.",
  },
];

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/commitments", label: "Priorities" },
  { to: "/ward11", label: "Ward 11" },
  { to: "/news", label: "News" },
  { to: "/questions", label: "Questions" },
  { to: "/get-involved", label: "Get Involved" },
  { to: "/contact", label: "Contact" },
];

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const SUBMISSION_LABELS = {
  volunteer: "Volunteer",
  lawn_sign: "Lawn Sign",
  updates: "Campaign Updates",
  priority: "Resident Priority",
  contact: "Contact Message",
};
